<template>
  <div class="tx-video" v-if="options.show">
    <div class="video-close" @click="options.show=false" v-if="options.closeBtn"></div>
    <video
      id="video"
      controls="controls"
      @click="play_video"
      style="object-fit:fill"
      webkit-playsinline="true"
      playsinline="true"
      :src="options.src"
      :autoplay="options.autoplay"
      :poster="options.poster"
    ></video>
    <img :src="options.play_btn" v-show="is_play" class="poster_img" />
  </div>
</template>

<script>
export default {
  name: "tx-video",
  props: {
    options: {
      type: Object,
      default() {
        return {
          show: {
            type: Boolean,
            default: false
          },
          src: {
            type: String,
            default: ""
          },
          autoplay: {
            type: Boolean,
            default: false
          },
          closeBtn: {
            type: Boolean,
            default: false
          },
          play_btn: {
            type: String,
            default: ""
          },
          poster: {
            type: String,
            default: ""
          }
        };
      }
    }
  },
  data() {
    return {
      is_play: !this.options.autoplay //是否播放
    };
  },
  components: {},
  mounted() {
    let that = this;

    //监听video状态
    var video = document.getElementById("video");
    if (video != null) {
      video.addEventListener("play", function() {
        that.is_play = false;
      });
      video.addEventListener("pause", function() {
        that.is_play = true;
      });
      video.addEventListener(
        "ended",
        function() {
          //播放完回到初始状态
          const videoSrc = video.currentSrc;
          video.src = "";
          video.src = videoSrc;
        },
        false
      );
    }
  },
  methods: {
    play_video() {
      var video = document.getElementById("video");
      if (this.is_play) {
        this.is_play = !this.is_play;
        video.pause();
      } else {
        this.is_play = !this.is_play;
        video.play();
      }
    }
  },
  watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.tx-video {
  // position: absolute;
  // left: 0;
  // top: 0;
  // background: rgba(0, 0, 0, 0.6);
  // width: -ms-page 100%;
  // height: 100%;
  z-index: 10001;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .video-close {
    background: url("//txwl.huohuoche.com/txws/new_images_one/close.png")
      no-repeat center center;
    background-size: 100% 100%;
    position: absolute;
    right: 18%;
    top: 7%;
    width: 30px;
    height: 30px;
    line-height: 30px;
    z-index: 999;
    cursor: pointer;
  }
  video {
    width: 60%;
    border: 1px solid #997e2c;
    border-radius: 4px;
    
  }
  .poster_img {
    width: 100px;
    position: absolute;
    left: 50%;
    top: 35%;
    margin-left: -50px;
    pointer-events: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/tx-video.vue